import * as React from 'react';
import styled from 'styled-components';

import { usePageContext } from '../../providers/PageContext';

const ScrollIndicator: React.FunctionComponent = () => {
  const ref = React.useRef<HTMLDivElement>(null);
  const pageContext = usePageContext();
  const scrollText = pageContext?.global?.scroll_text?.toUpperCase();

  React.useEffect(() => {
    let didScroll = false;
    const scrollIndicator = ref?.current;

    function checkScroll() {
      didScroll = true;
    }

    function hasScrolled() {
      const st = document.documentElement.scrollTop;

      if (scrollIndicator) {
        if (st > 0) {
          scrollIndicator.classList.add('hide');
        } else {
          scrollIndicator.classList.remove('hide');
        }
      }
    }

    const interval = window.setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    window.addEventListener('scroll', checkScroll);

    return () => {
      window.removeEventListener('scroll', checkScroll);
      window.clearInterval(interval);
    };
  });

  return (
    <ScrollIndicatorElement ref={ref}>
      {scrollText || 'SCROLL'}
    </ScrollIndicatorElement>
  );
};

const ScrollIndicatorElement = styled.div`
  display: none;
  position: fixed;
  z-index: 11;
  inset-inline-start: 20px;
  bottom: 110px;
  font-size: 10px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--grey-4);
  transform: rotate(-90deg);
  transition: all 0.3s linear;
  @media (min-width: 1180px) {
    display: block;
  }
  &::after {
    position: absolute;
    top: 7px;
    margin-inline-start: 3px;
    content: '';
    width: 50px;
    height: 1px;
    background: var(--grey-4);
  }
  &.hide {
    opacity: 0;
  }
`;

export default ScrollIndicator;
